module.exports = __webpack_public_path__ + "img/sx2.3fbeb032.png";